import React, { useEffect } from "react";

const ImagePreviewModal = ({ isOpen, onClose, imageUrl, altText = "Image Preview" }) => {
  // Close modal on Escape key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !imageUrl) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#34405499] backdrop-blur-sm p-4 transition-opacity duration-300"
      onClick={onClose} // Clicking the background closes the modal
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 md:top-6 md:right-6 text-gray-300 hover:text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-all focus:outline-none z-10"
        title="Close Preview"
      >
        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Image Container */}
      <div
        className="relative bg-white rounded-xl shadow-2xl flex items-center justify-center p-4 animate-fadeIn"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image itself
      >
        <img
          src={imageUrl}
          alt={altText}
          // Constrained dimensions to make the image smaller and neat
          className="max-w-[85vw] max-h-[70vh] md:max-w-[500px] md:max-h-[500px] object-contain"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
      </div>
    </div>
  );
};

export default ImagePreviewModal;